import './PreviewArea.css';
import { useStickyPreviewMotion } from '../../hooks/useStickyPreviewMotion';
import { motion, useTransform } from "framer-motion";

const PreviewArea = ({ scrollRef, children }) => {
  const previewHeight = useStickyPreviewMotion(scrollRef);
  const previewHeightVar = useTransform(previewHeight, v => `${v}px`);
  return (
    <div className='preview-area'>
      <motion.div
        className="preview-scroll"
        style={{ maxHeight: previewHeight, '--preview-height': previewHeightVar }}
      >
        {children}
      </motion.div>
    </div>
  )
}

export default PreviewArea